"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TrialPlanSubRow = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _return_arrow = _interopRequireDefault(require("../../../asset/icons/return_arrow.svg"));

var _globalContext = require("../../../services/context/globalContext");

var _lodash = _interopRequireDefault(require("lodash"));

var _DeleteEdit = _interopRequireDefault(require("../../DeleteEdit/DeleteEdit"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var isEqual = function isEqual(prevProps, nextProps) {
  if (!_lodash["default"].isEqual(prevProps, nextProps)) {
    return false;
  }

  return true;
};

var TrialPlanSubRow = function TrialPlanSubRow(props) {
  var passable = _react["default"].useContext(_globalContext.ModalContext);

  var value = _react["default"].useContext(_globalContext.ModalContext);

  var trialPlanHeaders = [['Name', 'coop_name'], ['Trial Set Name', ''], ['RM Range', ''], ['City', 'coop_city'], ['State', 'coop_state'], ['# of Trials', '']];
  var myMap = new Map(trialPlanHeaders);

  var fillRow = function fillRow(rowContent, _index) {
    var index = _index || 0;
    var coop_id = rowContent.coop_id;
    var trial_id = rowContent.trials[index].trial_id;
    var filler = [];
    myMap.forEach(function (value, key) {
      if (key === 'Name') {
        filler.push( /*#__PURE__*/_react["default"].createElement("div", {
          key: coop_id + '-' + key + '-' + trial_id,
          className: "cell"
        }, /*#__PURE__*/_react["default"].createElement("img", {
          src: _return_arrow["default"],
          className: "subMenu-button",
          alt: "return arrow"
        }), /*#__PURE__*/_react["default"].createElement("span", null, value && rowContent[value] ? rowContent[value] : '-')));
      } else if (key === 'RM Range') {
        filler.push( /*#__PURE__*/_react["default"].createElement("div", {
          key: coop_id + '-' + key + '-' + trial_id,
          className: "cell"
        }, /*#__PURE__*/_react["default"].createElement("span", null, rowContent.trials[index]['end_rm'] && rowContent.trials[index]['start_rm'] ? "".concat(rowContent.trials[index]['start_rm'], " - ").concat(rowContent.trials[index]['end_rm']) : '-')));
      } else if (key === 'Trial Set Name') {
        filler.push( /*#__PURE__*/_react["default"].createElement("div", {
          key: coop_id + '-' + key + '-' + trial_id,
          className: "cell"
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "subMenu-modalLink",
          onClick: function onClick(e) {
            return openModal(e, {
              cooperator: rowContent.coop_name,
              products: rowContent.trials[index].products,
              start_rm: rowContent.trials[index].start_rm,
              end_rm: rowContent.trials[index].end_rm,
              fet_unit: rowContent.trials[index].fet_unit,
              trial_name: rowContent.trials[index].trial_name,
              crop_type: rowContent.trials[index].crop_type,
              trial_id: trial_id
            });
          }
        }, rowContent.trials ? rowContent.trials[index].trial_name : '-')));
      } else if (key === '# of Trials') {
        filler.push( /*#__PURE__*/_react["default"].createElement("div", {
          key: value,
          className: "cell"
        }, /*#__PURE__*/_react["default"].createElement(_DeleteEdit["default"], {
          edit: function edit() {
            return passable.editTrial(rowContent, index);
          },
          "delete": function _delete() {
            return passable.deleteTrial(rowContent, index);
          }
        })));
      } else {
        filler.push( /*#__PURE__*/_react["default"].createElement("div", {
          key: coop_id + '-' + key + '-' + trial_id,
          className: "cell"
        }, value && rowContent[value] ? rowContent[value] : '-'));
      }
    });
    return filler;
  };

  var openModal = function openModal(e, products) {
    value.openTrial(products ? products : []);
    e.stopPropagation();
  };

  var clickHandler = function clickHandler(e) {
    e.stopPropagation();

    if (props.callBack) {
      props.callBack();
    }
  };

  var generateSubRows = function generateSubRows(rowContent) {
    var multipleRows = [];
    rowContent.trials.forEach(function (trial, index) {
      multipleRows.push( /*#__PURE__*/_react["default"].createElement("div", {
        key: rowContent.coop_id + '-' + index,
        className: "subMenu-row",
        onClick: function onClick(e) {
          return clickHandler(e);
        }
      }, fillRow(rowContent, index)));
    });
    return multipleRows;
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, generateSubRows(props.rowContent));
};

exports.TrialPlanSubRow = TrialPlanSubRow;

var _default = /*#__PURE__*/_react["default"].memo(TrialPlanSubRow, isEqual);

exports["default"] = _default;
TrialPlanSubRow.propTypes = {
  callBack: _propTypes.func,
  rowContent: (0, _propTypes.shape)({
    coop_city: _propTypes.string,
    coop_id: _propTypes.number,
    coop_name: _propTypes.string,
    coop_state: _propTypes.string,
    reseller_id: _propTypes.number
  })
};